import moment from "moment";
import "moment-duration-format";
import { Moment, unitOfTime } from "moment";
import { Set } from "immutable";

export function equalDateAndMoment(date1: Date, date2: Moment) {
    return moment(date1).format("YYYY-MM-DD") === date2.format("YYYY-MM-DD");
}

export function formatDuration(duration: number, unit: unitOfTime.DurationConstructor = "seconds") {
    return moment.duration(duration, unit).format();
}

export function keyIn(keys: Array<string | number>) {
    return (_value: any, key: string | number) => Set(keys).has(key);
}

export function getExcelSpreadsheetAccept() {
    return  [
        ".xlsx",
        ".xlsm",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel.sheet.macroEnabled.12",
    ].join(",");
}
